import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEIconCodes from '../../../../lib/oe-icon-codes';
import OEColor from '../../../color-picker/oe-color';
import OEIcon from '../../../elements/oe-icon';
import {OEMediaCenterItemTypes, OEMediaCenterItemLayoutType, OEMediaCenterIconType, OEMediaCenterItemFlags} from '../oe-media-center-model';
import {OEPresentationPlayableFlags, OEPresentationDefaultAnimatableState} from '../../presentation/oe-presentation-model';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import retardUpdate from '../../../../lib/react/update-retarder';

export default class OEMediaCenterItemStd extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.thumbID = {pres: -1, slide: -1};

        this.defStats = {
            hasStats: false,
            duration: {duration: 0, slides: 0},
            isPlayable: false,
            hasAudioTrack: false,
        };

        this.state = {
            stats: clone(this.defStats),
            img: null
        };

        this.onPresentationDurationChanged = this.onPresentationDurationChanged.bind(this);
        this.onPresentationDataChanged = this.onPresentationDataChanged.bind(this);
        this.onPresentationAnimatableStateChanged = this.onPresentationAnimatableStateChanged.bind(this);
        this.onPresentationSlideAdded = this.onPresentationSlideAdded.bind(this);
        this.onPresentationSlideRemoved = this.onPresentationSlideRemoved.bind(this);
        this.onPresentationSlideMoved = this.onPresentationSlideMoved.bind(this);
        this.onPresentationSlideSet = this.onPresentationSlideSet.bind(this);

        this.onRef = this.onRef.bind(this);

        this.onClick = this.onClick.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);

        this.typeClasses = ['item-type-dummy', 'item-type-animation', 'item-type-accessory', 'item-type-image', 'item-type-video', 'item-type-timeline', 'item-type-html', 'item-type-pdf', 'item-type-presentation', 'item-type-separator'];
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.item.id !== this.props.item.id)    {
            if(nextProps.elementRef)    {
                nextProps.elementRef(null, this.props.item.id);
                nextProps.elementRef(this.ref, nextProps.item.id);
            }
        } else if(nextProps.elementRef !== this.props.elementRef)   {
            if(nextProps.elementRef)   nextProps.elementRef(this.ref, nextProps.item.id);
        }

        if(nextProps.item.type !== this.props.item.type || nextProps.item.item.index !== this.props.item.item.index || nextProps.presPlayableFlags !== this.props.presPlayableFlags)  {
            this.updateStats(nextProps);
        }

        if(nextProps.noImages != this.props.noImages || nextProps.noPresThumbImages != this.props.noPresThumbImages || nextProps.item.id !== this.props.item.id || nextProps.item.type !== this.props.item.type || !!nextProps.item.img !== !!this.props.item.img || nextProps.item.item.index !== this.props.item.item.index || nextProps.item.item.flags !== this.props.item.item.flags)  {
            this.updateImage(false, nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationDurationChanged, this.onPresentationDurationChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationAnimatableStateChanged, this.onPresentationAnimatableStateChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideAdded, this.onPresentationSlideAdded);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideRemoved, this.onPresentationSlideRemoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideMoved, this.onPresentationSlideMoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideSet, this.onPresentationSlideSet);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationDurationChanged, this.onPresentationDurationChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationAnimatableStateChanged, this.onPresentationAnimatableStateChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideAdded, this.onPresentationSlideAdded);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideRemoved, this.onPresentationSlideRemoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideMoved, this.onPresentationSlideMoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideSet, this.onPresentationSlideSet);
    }

    updateStats(props)  {
        if(!this.oe.isReady()) return;
        props = props || this.props;

        if(props.item.type !== this.oe.Module.MediaCenterItemType.presentation) {
            this.setState({stats: clone(this.defStats)});
            return;
        }

        let pres = this.oe.sharedInterface.getUIControllerPresentation();
        let animatableState = pres.getPresentationAnimatableStateID(props.item.item.index) || OEPresentationDefaultAnimatableState;
        let presPlayableFlags = pres.getPresentationPlayableFlagsID(props.item.item.index);
        if(typeof(presPlayableFlags) !== 'number')  presPlayableFlags = props.presPlayableFlags;

        let stats = {
            hasStats: true,
            duration: {
                duration: pres.getPresentationDurationID(props.item.item.index),
                slides: animatableState.previewSlideCount
            },
            isPlayable: OEPresentationPlayableFlags.isPlayable(presPlayableFlags, animatableState),
            hasAudioTrack: animatableState.hasAudioTrack
        };

        this.setState({stats: stats});
    }

    updateImage(force, props)   {
        props = props || this.props;

        if(this.props.noImages || this.props.noPresThumbImages || !this.oe.isReady() || props.item.type !== this.oe.Module.MediaCenterItemType.presentation || props.item.img || !!(props.item.item.flags & OEMediaCenterItemFlags.noThumbImage))  {
            this.thumbID = {pres: -1, slide: -1};
            this.setState({img: null});
            return;
        }

        let pres = this.oe.sharedInterface.getUIControllerPresentation();
        
        let presID = props.item.item.index;
        let iPres = pres.getPresentationIndexForID(presID);
        let slideID = pres.getSlideID(iPres, 0);

        if(slideID < 0) {
            this.thumbID = {pres: -1, slide: -1};
            this.setState({img: null});
            return;
        }

        if(this.thumbID.pres === presID && this.thumbID.slide === slideID && !force)   return;

        this.thumbID = {pres: presID, slide: slideID};

        pres.getThumbnailID(this.thumbID.pres, slideID, (thumb, presID, slideID) => {
            if(this.thumbID.pres !== presID || this.thumbID.slide !== slideID)   return;
            this.setState({img: thumb});
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.thumbID = {pres: -1, slide: -1};
            this.setState({
                stats: clone(this.defStats),
                img: null
            });
            return;
        }

        retardUpdate(this, () => {
            this.updateStats();
            this.updateImage(true);
        });
    }

    onPresentationDurationChanged(message, userInfo) {
        if(this.props.item.type !== this.oe.Module.MediaCenterItemType.presentation || userInfo.presID !== this.props.item.item.index)  return;
        this.updateStats();
    }

    onPresentationDataChanged(message, userInfo)    {
        if(this.props.item.type !== this.oe.Module.MediaCenterItemType.presentation || userInfo.presID !== this.props.item.item.index || !(userInfo.changeFlags & this.oe.Module.PresentationDataChangeFlags.playable.value))    return;
        this.updateStats();
    }

    onPresentationAnimatableStateChanged(message, userInfo) {
        if(this.props.item.type !== this.oe.Module.MediaCenterItemType.presentation || userInfo.presID !== this.props.item.item.index)  return;
        this.updateStats();
    }

    onPresentationSlideAdded(message, userInfo)    {
        if(userInfo.presID !== this.thumbID.pres || userInfo.slide > 0) return;
        this.updateImage(true);
    }

    onPresentationSlideRemoved(message, userInfo)    {
        this.onPresentationSlideAdded(message, userInfo);
    }
    
    onPresentationSlideMoved(message, userInfo)    {
        if(this.thumbID.pres < 0 || (userInfo.slideSrc !== 0 && userInfo.slideDst !== 0))    return;

        if((userInfo.slideSrc === 0 && this.thumbID.pres === userInfo.presSrcID) || (userInfo.slideDst === 0 && this.thumbID.pres === userInfo.presDstID))    {
            this.updateImage(true);
        }
    }

    onPresentationSlideSet(message, userInfo)    {
        if(userInfo.presID !== this.thumbID.pres || userInfo.slideID !== this.thumbID.slide) return;
        this.updateImage(true);
    }

    onRef(ref) {
        if(this.ref === ref) return;
        this.ref = ref;
        if(this.props.elementRef)   this.props.elementRef(ref, this.props.item.id);
    }

    renderItem()    {
        let type = this.props.item.type;
        let typeClassName = this.typeClasses[typeof(type) !== 'undefined' && type.value >= 0 && type.value < this.typeClasses.length ? type.value : 0];

        //
        if(type.value === OEMediaCenterItemTypes.separator)    {
            return (
                <div
                    className={'media-center-item-std ' + typeClassName + ' ' + this.props.className}
                    style={this.props.style}
                    ref={this.onRef}
                >
                    <div className="content">
                        <div className="container">
                            <div className="label">
                                {this.props.item.label}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        //
        let style = {};
        if(!this.props.noImages)  {
            style.backgroundImage = this.props.item.img ? 'url(' + encodeURI(this.props.item.img) + ')' : (this.state.img ? 'url(' + encodeURI(this.state.img) + ')' : undefined);
        }

        //
        return (
            <div
                className={'extra-light-hover-bg media-center-item-std ' + typeClassName + ' ' + this.props.className + (this.props.selected ? ' selected' : '') + (!this.props.enabled ? ' disabled' : '')}
                style={this.props.style}
                ref={this.onRef}
                onClick={this.onClick}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
            >
                <div
                    className={'content' + (this.props.item.layoutType === OEMediaCenterItemLayoutType.nameTop ? ' name-top' : '')}
                >
                    <div
                        className={'container' + (style.backgroundImage ? (this.props.item.img ? ' bg-image item-bg-image' : ' bg-image state-bg-image') : ' no-bg-image')}
                        style={style}
                    >
                        <div className="head">
                            <div className="content">

                                {!((this.props.showIndex && this.props.item.showNumber) || this.props.forceShowIndex) ? null :
                                    <span className="number">{(this.props.index + 1).toString()}</span>
                                }

                                {!this.props.showIcon ? null :
                                    <OEIcon
                                        className={this.props.item.icon.type === OEMediaCenterIconType.text ? 'default-font text' : ''}
                                        style={{color: OEColor.toDOMStr(this.props.item.icon.color)}}
                                        code={this.props.item.icon.code}
                                    />
                                }

                            </div>
                        </div>

                        {!(this.props.showLabel && this.props.item.showLabel) ? null :
                            <div className="label">
                                {this.props.item.label}
                            </div>
                        }

                        <div className="footer">
                            <div className="content">

                                {!(this.props.showStats && this.state.stats.hasStats) ? null :
                                    <div className="stats">
                                        
                                        {this.state.stats.isPlayable ?
                                            <div className="duration">
                                                <OEIcon code={OEIconCodes.mcPresentationDuration}/>{OEToolbox.numberToString(Math.floor(this.state.stats.duration.duration / 60), 2) + ':' + OEToolbox.numberToString(Math.floor(this.state.stats.duration.duration % 60), 2)}
                                            </div> :
                                            <div className="duration">
                                                <OEIcon code={OEIconCodes.mcPresentationSlides}/>{this.state.stats.duration.slides.toString()}
                                            </div>
                                        }

                                        <OEIcon className="sound-icon" code={this.state.stats.hasAudioTrack ? OEIconCodes.mcItemWithSound : OEIconCodes.mcItemWithoutSound}/>

                                    </div>
                                }

                            </div>
                        </div>

                    </div>

                </div>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                {this.renderItem()}
            </React.Fragment>
        );
    }

    onClick()   {
        if(this.props.onClick)  this.props.onClick(this.props.index, this.props.item.id);
    }

    onMouseEnter()  {
        if(this.props.onMouseEnter) this.props.onMouseEnter(this.props.index, this.props.item.id);
    }

    onMouseLeave()  {
        if(this.props.onMouseLeave) this.props.onMouseLeave(this.props.index, this.props.item.id);
    }
}

OEMediaCenterItemStd.defaultProps = {
    className: '',
    moduleId: '',
    enabled: true,
    selected: false,
    showIndex: true,
    forceShowIndex: false,
    showIcon: true,
    showLabel: true,
    showStats: false,
    noImages: false,
    noPresThumbImages: false,
    presPlayableFlags: OEPresentationPlayableFlags.all
};

OEMediaCenterItemStd.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    moduleId: PropTypes.string,
    enabled: PropTypes.bool,
    selected: PropTypes.bool,
    showIndex: PropTypes.bool,
    forceShowIndex: PropTypes.bool,
    showIcon: PropTypes.bool,
    showLabel: PropTypes.bool,
    showStats: PropTypes.bool,
    noImages: PropTypes.bool,
    noPresThumbImages: PropTypes.bool,
    presPlayableFlags: PropTypes.number,
    elementRef: PropTypes.func,     // function(ref, id) {},
    onClick: PropTypes.func,        // function(index, id) {},
    onMouseEnter: PropTypes.func,   // function(index, id) {},
    onMouseLeave: PropTypes.func    // function(index, id) {},
};